module.exports = __webpack_public_path__ + "static/img/home6.551718e9.png";